import { ProgramType } from './ProgramTypes';
import { UserPermissions } from './UserTypes';

export enum OrganizationPricingTabType {
  mappings = 'mappings',
  energyCommunity = 'energyCommunity',
  ppwModifiers = 'ppwModifiers',
  domesticContent = 'domesticContent',
  holdbacks = 'holdbacks',
  equipmentSettings = 'equipmentSettings',
  siteSurvey = 'siteSurvey',
  propertyType = 'propertyType',
}

export interface OrganizationPricingTabConfig {
  label: string;
  permissions?: UserPermissions[];
}

export const programTypeOrganizationPricingTabMap: {
  [Key in ProgramType]?: { [key in OrganizationPricingTabType]?: OrganizationPricingTabConfig };
} = {
  [ProgramType.solar]: {
    [OrganizationPricingTabType.mappings]: { label: 'Mappings' },
    [OrganizationPricingTabType.energyCommunity]: { label: 'Energy Community' },
    [OrganizationPricingTabType.ppwModifiers]: { label: 'PPW Modifiers' },
    [OrganizationPricingTabType.domesticContent]: { label: 'Domestic Content' },
    [OrganizationPricingTabType.holdbacks]: { label: 'Holdbacks' },
    [OrganizationPricingTabType.equipmentSettings]: {
      label: 'Equipment Settings',
      permissions: [UserPermissions.lightReachSafeHarborEquipmentPricing],
    },
    [OrganizationPricingTabType.siteSurvey]: {
      label: 'Site Survey',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
    [OrganizationPricingTabType.propertyType]: {
      label: 'Property Type',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
  },
  [ProgramType.doePr]: {
    [OrganizationPricingTabType.mappings]: { label: 'Mappings' },
    [OrganizationPricingTabType.siteSurvey]: {
      label: 'Site Survey',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
    [OrganizationPricingTabType.propertyType]: {
      label: 'Property Type',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
  },
  [ProgramType.newHomes]: {
    [OrganizationPricingTabType.mappings]: { label: 'Mappings' },
    [OrganizationPricingTabType.energyCommunity]: { label: 'Energy Community' },
    [OrganizationPricingTabType.ppwModifiers]: { label: 'PPW Modifiers' },
    [OrganizationPricingTabType.domesticContent]: { label: 'Domestic Content' },
    [OrganizationPricingTabType.holdbacks]: { label: 'Holdbacks' },
    [OrganizationPricingTabType.equipmentSettings]: {
      label: 'Equipment Settings',
      permissions: [UserPermissions.lightReachSafeHarborEquipmentPricing],
    },
    [OrganizationPricingTabType.siteSurvey]: {
      label: 'Site Survey',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
    [OrganizationPricingTabType.propertyType]: {
      label: 'Property Type',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
  },
  [ProgramType.hvac]: {
    [OrganizationPricingTabType.mappings]: { label: 'Mappings' },
    [OrganizationPricingTabType.siteSurvey]: {
      label: 'Site Survey',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
    [OrganizationPricingTabType.propertyType]: {
      label: 'Property Type',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
  },
  [ProgramType.waterHeater]: {
    [OrganizationPricingTabType.mappings]: { label: 'Mappings' },
    [OrganizationPricingTabType.siteSurvey]: {
      label: 'Site Survey',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
    [OrganizationPricingTabType.propertyType]: {
      label: 'Property Type',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
  },
  [ProgramType.generator]: {
    [OrganizationPricingTabType.mappings]: { label: 'Mappings' },
  },
  [ProgramType.geothermal]: {
    [OrganizationPricingTabType.mappings]: { label: 'Mappings' },
    [OrganizationPricingTabType.energyCommunity]: { label: 'Energy Community' },
    [OrganizationPricingTabType.siteSurvey]: {
      label: 'Site Survey',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
    [OrganizationPricingTabType.propertyType]: {
      label: 'Property Type',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
  },
  [ProgramType.energyBackup]: {
    [OrganizationPricingTabType.mappings]: { label: 'Mappings' },
    [OrganizationPricingTabType.siteSurvey]: {
      label: 'Site Survey',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
    [OrganizationPricingTabType.propertyType]: {
      label: 'Property Type',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
  },
  [ProgramType.consumerSolar]: {
    [OrganizationPricingTabType.mappings]: { label: 'Mappings' },
    [OrganizationPricingTabType.domesticContent]: { label: 'Domestic Content' },
    [OrganizationPricingTabType.holdbacks]: { label: 'Holdbacks' },
    [OrganizationPricingTabType.ppwModifiers]: { label: 'PPW Modifiers' },
    [OrganizationPricingTabType.siteSurvey]: {
      label: 'Site Survey',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
    [OrganizationPricingTabType.propertyType]: {
      label: 'Property Type',
      permissions: [UserPermissions.lightReachAccountingSettings],
    },
  },
} as const;
